export const bucketFitScore = (score: number | undefined) => {
    if (!score) {
    return 'Unknown'
    } else if (score < 0.15) {
    return 'Poor'
    } else if (score < 0.5) {
    return 'Fair'
    } else if (score < 0.85) {
    return 'Good'
    } else {
    return 'Excellent'
    }
}